export const getAuthToken = () => {
  return localStorage.getItem('authToken') || sessionStorage.getItem('authToken');
};

const REMEMBER_KEY = 'authRememberMe';
const AUTH_NOTICE_KEY = 'authNotice';

export const setRememberMe = (remember) => {
  if (remember === true) {
    localStorage.setItem(REMEMBER_KEY, '1');
    sessionStorage.removeItem(REMEMBER_KEY);
    return;
  }

  if (remember === false) {
    sessionStorage.setItem(REMEMBER_KEY, '0');
    localStorage.removeItem(REMEMBER_KEY);
  }
};

export const getRememberMe = () => {
  if (localStorage.getItem(REMEMBER_KEY) === '1') return true;
  if (sessionStorage.getItem(REMEMBER_KEY) === '0') return false;
  return true;
};

export const getAppStorage = () => {
  return getRememberMe() ? localStorage : sessionStorage;
};

export const setAuthToken = (token, remember = null) => {
  if (!token) return;

  if (remember === true) {
    localStorage.setItem('authToken', token);
    sessionStorage.removeItem('authToken');
    setRememberMe(true);
    return;
  }

  if (remember === false) {
    sessionStorage.setItem('authToken', token);
    localStorage.removeItem('authToken');
    setRememberMe(false);
    return;
  }

  if (localStorage.getItem('authToken')) {
    localStorage.setItem('authToken', token);
    return;
  }

  if (sessionStorage.getItem('authToken')) {
    sessionStorage.setItem('authToken', token);
    return;
  }

  localStorage.setItem('authToken', token);
  setRememberMe(true);
};

export const clearAuthToken = () => {
  localStorage.removeItem('authToken');
  sessionStorage.removeItem('authToken');
};

export const clearAllStorage = () => {
  localStorage.clear();
  sessionStorage.clear();
};

export const setAuthNotice = (message) => {
  if (!message) return;
  sessionStorage.setItem(AUTH_NOTICE_KEY, message);
};

export const consumeAuthNotice = () => {
  const message = sessionStorage.getItem(AUTH_NOTICE_KEY);
  if (message) {
    sessionStorage.removeItem(AUTH_NOTICE_KEY);
  }
  return message || '';
};
